/**
 * @copyright 2019 @ DigiNet
 * @author VINHLE
 * @create 2019/01/18 15:37
 * @update 2019/01/18 15:37
 * @file src/reducers/user.js
 */

import * as types from '../actions/types.js';

const initialState = {
    dataMaster: null,
    dataPopUp: null,
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case types.W18_W18F1018_DATAMASTER_COMPLETE:
            return {
                ...state,
                dataMaster: action.dataMaster
            };
        case types.W18_W18F1018_POPUP_COMPLETE:
            return {
                ...state,
                dataPopUp: action.dataPopUp
            };

        default:
            return state;
    }
}